import React, { Component } from 'react';
import './Logo.css';

class Logo extends Component {
  constructor(props){
     super(props)
     this.state = {
       text: this.props.text
     };
  }

  render() {
    return (
      <div className='Logo'>
        <button className='Logo-button'
                onClick={e => this.props.changePage(e, "Home")}>
            <p className='Logo-name font-serif'>Beth&nbsp;Simmons</p>
            <p className='Logo-tagline font-sans-serif'>knitwear designer</p>
        </button>
      </div>
    );
  }
}



export default Logo;
